import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AgGridModule } from 'ag-grid-angular';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { NgChartsModule } from 'ng2-charts';
import { GlazingListComponent } from './glazing-list/glazing-list.component';
import { ProductLibraryComponent } from './product-library/product-library.component';
import { ProductDetailComponent } from 'src/app/product-detail/product-detail.component';
import { ShadingListComponent } from 'src/app/shading-list/shading-list.component';
import { ProductService } from 'src/app/service/product.service';
import { APP_BASE_HREF } from '@angular/common';


@NgModule({
    declarations: [
        AppComponent,
        ProductLibraryComponent,
        GlazingListComponent,
        ShadingListComponent,
        ProductDetailComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        NoopAnimationsModule,
        MatCardModule,
        MatIconModule,
        MatToolbarModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatTabsModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        NgChartsModule,
        AgGridModule
    ],

    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        ProductService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
}
